import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BuildConfigService } from '@common/util-foundation';
import { ReinstateDirectDebitRequest } from '@common/util-models';
import { Observable } from 'rxjs';
import { PostHogService } from '@tracking/posthog/posthog.service';
import { PostHogFeatureFlags } from '@tracking/posthog/models/posthog-feature-flags.enum';

@Injectable()
export class ReinstateApiService {
  constructor(
    private httpClient: HttpClient,
    private buildConfigService: BuildConfigService,
    private posthogService: PostHogService
  ) {}

  reinstateDirectDebit(
    requestData: ReinstateDirectDebitRequest
  ): Observable<void> {
    // ESB API call
    const config = this.buildConfigService.config;
    const reinstateDirectDebitUrl = `${config.common}/directdebit/reinstate`;
    return this.httpClient.post<void>(reinstateDirectDebitUrl, requestData, {
      headers: {
        ...this.getHeaders(),
      },
    });
  }

  sendCustomerSupportDirectDebit(
    requestData: ReinstateDirectDebitRequest
  ): Observable<void> {
    // Customer support API call
    return this.httpClient.post<void>(
      `${this.buildConfigService.config.commonCustomerSupportApi}/api/v1/reinstate-direct-debit`,
      {
        data: {
          context: {
            email: requestData.email,
            lastName: requestData.last_name,
            planNumber: requestData.plan_number,
            postcode: requestData.postcode,
            client: this.buildConfigService.config.wlClient,
          },
        },
      }
    );
  }

  isCustomerSupportAPIEnabled(): boolean {
    return this.posthogService.isFeatureEnabled(
      PostHogFeatureFlags.CustomerSupportReinstateDirectDebit
    );
  }

  private getHeaders() {
    return {
      'wl-client': this.buildConfigService.config.wlClient,
      'request-source': this.buildConfigService.config.catalogueStore,
      'request-action': this.buildConfigService.config.action,
    };
  }
}
